import { type useFetcher } from '@remix-run/react'
import { createContext, useContext } from 'react'
import { type GeneratedImage2 } from '#app/routes/resources+/generated-images'
import { type ImageId } from '#app/utils/handle-image-selection'
import { type WorkflowType } from '#app/utils/helpers'

export type SelectionContextType = {
	handleSelection?: (
		img: ImageId,
		fetcher: ReturnType<typeof useFetcher>,
	) => void
	selectedImagesIds?: ImageId[]
	enableSelection?: boolean
	handleDialogImageClick?: (image: GeneratedImage2, type: WorkflowType) => void
}

const SelectionContext = createContext<SelectionContextType | null>(null)

export const SelectionProvider = SelectionContext.Provider

export function useSelectionContext() {
	const context = useContext(SelectionContext)
	if (!context) {
		throw new Error(
			'useSelectionContext must be used within a SelectionProvider',
		)
	}
	return context
}
